export const isKeyEnterPressed = key => key && ['Enter', ' '].includes(key);